export default __webpack_public_path__ + "static/InstantPreviewHeading-e5472d5be98894b514b0a893e607e994.svg";